import {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
  type ReactNode,
} from "react";
import { C, FONT } from "../theme";

const ToastCtx = createContext<(msg: string) => void>(() => {});

export const useToast = () => useContext(ToastCtx);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [msg, setMsg] = useState("");
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const toast = useCallback((m: string) => {
    setMsg(m);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setMsg(""), 2800);
  }, []);

  return (
    <ToastCtx.Provider value={toast}>
      {children}
      {msg && (
        <div
          style={{
            position: "fixed",
            bottom: 28,
            left: "50%",
            transform: "translateX(-50%)",
            background: C.panel,
            border: `1px solid ${C.line3}`,
            color: C.textBright,
            padding: "11px 20px",
            borderRadius: 8,
            font: `600 13px ${FONT}`,
            zIndex: 99999,
            boxShadow: "0 8px 30px rgba(0,0,0,.5)",
            animation: "fadeup .25s ease",
          }}
        >
          {msg}
        </div>
      )}
    </ToastCtx.Provider>
  );
}
